import MetaFootballModel from "../../Football/Models/Pagination/MetaFootballModel";
import ActivityResponseBody from "./ActivityResponseBody";

export default class PaginationActivities {
  public meta: MetaFootballModel = new MetaFootballModel();
  public data: ActivityResponseBody[] = [new ActivityResponseBody()];
}
